module.exports = __webpack_public_path__ + "static/media/Source Info.8cac0d67.txt";